import { lazy, Suspense } from 'react'

import { createFileRoute } from '@tanstack/react-router'

import { ErrorBoundary } from '@/components/common/error-boundary'
import { Skeleton } from '@/components/ui/skeleton'

const DetailsEvidence = lazy(() =>
	import('@/features/air/case-management/components/details/evidence/details-evidence').then(
		(m) => ({ default: m.DetailsEvidence }),
	),
)

export const Route = createFileRoute(
	'/_dashboard/air/case-management/$id/evidence',
)({
	head: ({ params }) => ({
		meta: [
			{
				title: `Evidence · Case ${params.id} | Case Management | BitLyft AIR®`,
			},
		],
	}),
	component: RouteComponent,
})

function RouteComponent() {
	const { id } = Route.useParams()

	return (
		<ErrorBoundary feature="case-management" section="evidence" entityId={id}>
			<Suspense fallback={<Skeleton className="h-64 w-full" />}>
				<DetailsEvidence id={id} />
			</Suspense>
		</ErrorBoundary>
	)
}
